// Encuestas: tipos (espejo de apps/api/src/lib/mkt-survey-core.ts).
export type QuestionType = "short" | "long" | "single" | "multiple" | "dropdown" | "scale5" | "scale10" | "nps" | "yesno" | "email" | "phone" | "name";
export type ContactMap = "email" | "fullName" | "firstName" | "lastName" | "phone" | "company" | "title" | "city";
export interface ShowIf { q: string; op: "eq" | "neq" | "includes" | "answered"; value?: string }
export interface Question {
  id: string; type: QuestionType; label: string; description?: string; required?: boolean; options?: string[];
  placeholder?: string; map?: ContactMap | null; showIf?: ShowIf | null;
}
export interface SurveySettings {
  intro?: { title?: string; text?: string }; thankYou?: string; redirectUrl?: string; buttonLabel?: string;
  tags?: string[]; listIds?: string[]; createAccount?: boolean; color?: string;
  consent?: { enabled: boolean; text?: string; policyUrl?: string };
}
export interface Survey {
  id: string; name: string; status: "draft" | "published"; publicToken: string; questions: Question[]; settings: SurveySettings;
  folder: string | null; impressions: number; responsesCount: number; contactsCreated: number; createdAt: string; updatedAt: string;
}
export interface SurveyListRow extends Omit<Survey, "questions" | "settings" | "publicToken"> { creator: string | null }

export const QTYPE_LABEL: Record<QuestionType, string> = {
  short: "Texto corto", long: "Texto largo", single: "Opción única", multiple: "Opción múltiple", dropdown: "Desplegable",
  scale5: "Escala 1-5", scale10: "Escala 1-10", nps: "NPS 0-10", yesno: "Sí / No", email: "Correo electrónico", phone: "Teléfono", name: "Nombre",
};
export const MAP_LABEL: Record<ContactMap, string> = {
  email: "Correo", fullName: "Nombre completo", firstName: "Nombre", lastName: "Apellidos", phone: "Teléfono", company: "Empresa", title: "Cargo", city: "Ciudad",
};
export const hasOptions = (t: QuestionType): boolean => t === "single" || t === "multiple" || t === "dropdown";

/** Valores posibles de una pregunta para usarla en una condición. */
export function conditionValues(q: Question): Array<{ value: string; label: string }> {
  if (hasOptions(q.type)) return (q.options ?? []).map((o) => ({ value: o, label: o }));
  if (q.type === "yesno") return [{ value: "yes", label: "Sí" }, { value: "no", label: "No" }];
  if (q.type === "scale5") return [1, 2, 3, 4, 5].map((n) => ({ value: String(n), label: String(n) }));
  if (q.type === "scale10") return Array.from({ length: 10 }, (_, i) => ({ value: String(i + 1), label: String(i + 1) }));
  if (q.type === "nps") return Array.from({ length: 11 }, (_, i) => ({ value: String(i), label: String(i) }));
  return [];
}
